// Credenco house style, taken from the design tokens on credenco.com.
export const brand = {
    navy: '#03133D',
    navy800: '#0A1F5C',
    panel: '#2C5AA0',
    panelDeep: '#1F4378',
    accent: '#8BB8FF',
    accentSoft: '#93C2FA',
    accentLight: '#DBE8FA',
    blue: '#2563A6',
    green: '#52F362',
    text: '#4A5A78',
    surface: '#FFFFFF',
    background: '#F0F6FF',
    backgroundAlt: '#EEF4FF',
    border: '#E6ECF5',
};

export const brandFont = "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

// The hero on credenco.com is a rounded panel inset from a light page, not a full-bleed band.
export const heroGradient = `radial-gradient(120% 120% at 78% 30%, ${brand.panel} 0%, ${brand.panelDeep} 55%, ${brand.navy} 100%)`;

export const radius = {
    panel: '28px',
    card: '16px',
    pill: '999px',
};

export const shadow = {
    card: '0 2px 8px rgba(3, 19, 61, 0.06)',
    lifted: '0 18px 40px rgba(3, 19, 61, 0.28)',
};

// Here and not in the page component: PhaseSection needs them too, and importing
// them from the page would be circular.
export const pillButton = {
    borderRadius: radius.pill,
    textTransform: 'none' as const,
    fontWeight: 700,
    fontSize: '1rem',
    padding: '11px 26px',
    boxShadow: 'none',
};

// Pair with variant="outlined". MUI drops the border width on hover, hence the repeat.
export const outlinePillButton = {
    ...pillButton,
    borderColor: brand.navy,
    borderWidth: '1.5px',
    color: brand.navy,
    background: brand.surface,
    '&:hover': {
        borderColor: brand.navy,
        borderWidth: '1.5px',
        background: brand.backgroundAlt,
    },
};
